var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconAwesomeUserAlt = function SvgIconAwesomeUserAlt(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.174,
    height: 40.174,
    viewBox: "0 0 40.174 40.174",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt",
    "data-name": "Icon awesome-user-alt",
    d: "M20.087,22.6a11.3,11.3,0,1,0-11.3-11.3A11.3,11.3,0,0,0,20.087,22.6Zm10.044,2.511H25.807a13.659,13.659,0,0,1-11.44,0H10.044A10.043,10.043,0,0,0,0,35.153v1.255a3.767,3.767,0,0,0,3.766,3.766H36.408a3.767,3.767,0,0,0,3.766-3.766V35.153A10.043,10.043,0,0,0,30.131,25.109Z",
    fill: "#307fe2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconAwesomeUserAlt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Icon awesome-user-alt.2497cd82f12512efae73ddcfb63716dc.svg";